import * as React from "react";
import { Formik, Form } from "formik";
import { useTranslation } from "react-i18next";
import { Input, Button, ButtonToolbar } from "components/bootstrap";
const defaultInputProfile = { id: "", title: "", description: "" };
const InputProfileForm = ({
  inputProfile = defaultInputProfile,
  onCancel,
  onSubmit,
  buttonToolbarClassName = void 0,
  buttonText = void 0,
  InputsWrapper = React.Fragment,
  ActionsWrapper = React.Fragment
}) => {
  const { t } = useTranslation("enterprise_forwarder");
  const effectiveButtonText = buttonText != null ? buttonText : t("input_profile_form.save");
  const { title, description } = inputProfile || defaultInputProfile;
  const EffectiveInputsWrapper = InputsWrapper || React.Fragment;
  const EffectiveActionsWrapper = ActionsWrapper || React.Fragment;
  return /* @__PURE__ */ React.createElement(Formik, { initialValues: { title, description }, onSubmit }, ({ values, handleChange, isSubmitting }) => /* @__PURE__ */ React.createElement(Form, { role: "form" }, /* @__PURE__ */ React.createElement(EffectiveInputsWrapper, null, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "title",
      name: "title",
      label: t("input_profile_form.title_label"),
      type: "text",
      value: values.title,
      onChange: handleChange,
      help: t("input_profile_form.title_help"),
      required: true
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "description",
      name: "description",
      label: t("input_profile_form.description_label"),
      type: "text",
      value: values.description,
      onChange: handleChange,
      help: t("input_profile_form.description_help")
    }
  )), /* @__PURE__ */ React.createElement(EffectiveActionsWrapper, null, /* @__PURE__ */ React.createElement(ButtonToolbar, { className: buttonToolbarClassName }, /* @__PURE__ */ React.createElement(Button, { onClick: onCancel }, t("input_profile_form.cancel")), /* @__PURE__ */ React.createElement(Button, { type: "submit", bsStyle: "primary", disabled: isSubmitting }, isSubmitting ? t("input_profile_form.saving") : effectiveButtonText)))));
};
export default InputProfileForm;
